import { useState } from 'react'
import { isEmpty } from 'remeda'
import { ShopTheLookModal } from '@components/ShopTheLookModal/ShopTheLookModal'
import { LookbookBlock } from '@velasca/ui/lookbook-block'
import { ShopButton } from './LookItem.styles'
import type { LookItemProps } from './LookItem.types'

export const LookItem = ({
  drawerTitle,
  popupTitle,
  popupSubtitle,
  layoutType,
  look,
  position,
}: LookItemProps) => {
  const { media, productIDs } = look
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  return (
    <ShopTheLookModal
      drawerTitle={drawerTitle}
      title={popupTitle}
      subtitle={popupSubtitle}
      productIDs={productIDs}
      isOpen={isPopupOpen}
      onClose={setIsPopupOpen}
    >
      {!isEmpty(productIDs) && (
        <ShopButton
          onClick={() => {
            setIsPopupOpen(true)
          }}
        />
      )}
      {layoutType === 'layout1' && <LookbookBlock.Layout1.Item media={media} />}
      {layoutType === 'layout2' && <LookbookBlock.Layout2.Item media={media} />}
      {layoutType === 'layout3' && (
        <LookbookBlock.Layout3.Item media={media} position={position} />
      )}
      {layoutType === 'layout4' && <LookbookBlock.Layout4.Item media={media} />}
      {layoutType === 'layout5' && <LookbookBlock.Layout5.Item media={media} />}
      {layoutType === 'layout6' && <LookbookBlock.Layout6.Item media={media} />}
      {layoutType === 'layout7' && (
        <LookbookBlock.Layout7.Item media={media} position={position} />
      )}
    </ShopTheLookModal>
  )
}
